import resourceConfig from '../config';

export default {
  resources: {
    [resourceConfig.name]: {
      openAction: 'Load template',
      title: 'Load ATK templates',
      executeAction: 'Upload',
      cancelAction: 'Cancel',
      selectFiles: 'Select files',
      sendToGisMt: 'Send to GIS MT',
      filesSelected: 'Files selected: %{count} (max %{max})',
      successMessage: 'All files uploaded successfully',
      partialSuccessMessage: 'Some files uploaded with errors',
      errorMessage: 'Upload error',
      status: {
        pending: 'Pending',
        uploading: 'Uploading',
        success: 'Uploaded',
        error: 'Error',
      },
    },
  },
};
